// 用户预约扫墓
import request from "@/utils/request";

//保存预约信息 返回预约码
export function appointmentSacrifice_operation(data) {
  return request({
    url: "/sys/appointmentSacrifice/operation",
    method: "post",
    data,
  });
}
// 获取预约公墓列表
export function cemeteryFuneralInfo_findALL(data) {
  return request({
    url: "/app/cemeteryFuneralInfo/findALL",
    method: "post",
    data,
  });
}
